import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import { adminPushStreamUrl, sendAdminAck } from '../../api/adminPush';
import { adminPushBus } from '../../utils/adminPushBus';

let noticeSeq = 0;

const fmtTime = (at) => {
  if (!at) return '';
  try { return new Date(Number(at)).toLocaleString('ko-KR', { hour12: false }); } catch { return ''; }
};

/**
 * 로그인 상태의 어느 화면에서든 슈퍼관리자 실시간 메시지를 알림 카드로 띄우는 전역 컴포넌트.
 * - 수신 메시지: 자동으로 사라지지 않고 '수신확인' 버튼을 눌러야 닫힌다. 보낸시각을 함께 표시.
 * - 수신확인(ACK): 수신자가 확인을 누르면 발신자에게 되돌아와, 발신자 화면에 "누가/언제 확인" 을 잠깐 띄운다.
 */
export default function RealtimeNotifier() {
  const { auth } = useAuth();
  const [notices, setNotices] = useState([]); // 수신 메시지(확인 눌러야 닫힘)
  const [acks, setAcks] = useState([]);       // 발신자에게 오는 수신확인(자동 소멸)
  const token = auth?.accessToken;
  const adminName = auth?.adminName;

  const confirm = useCallback((n) => {
    if (n.messageId && n.senderAccount) {
      // 발신자에게 수신확인 전송(실패해도 카드는 닫는다).
      sendAdminAck({ messageId: n.messageId, senderAccount: n.senderAccount, receiverName: adminName }).catch(() => {});
    }
    setNotices((list) => list.filter((x) => x.id !== n.id));
  }, [adminName]);

  useEffect(() => {
    if (!token) return undefined;
    const es = new EventSource(adminPushStreamUrl(token));

    es.addEventListener('admin-message', (e) => {
      let d = {};
      try { d = JSON.parse(e.data); } catch { d = { message: e.data }; }
      setNotices((list) => [...list, {
        id: ++noticeSeq, messageId: d.messageId, senderAccount: d.senderAccount,
        message: d.message || '', sender: d.sender || '', at: d.at,
      }]);
    });

    es.addEventListener('admin-ack', (e) => {
      let d = {};
      try { d = JSON.parse(e.data); } catch { d = {}; }
      const ack = { id: ++noticeSeq, receiverName: d.receiverName || d.receiverAccount || '', receiverAccount: d.receiverAccount || '', at: d.at };
      setAcks((list) => [...list, ack]);
      adminPushBus.emitAck(ack); // 발신 화면(AdminPushPage) 수신확인 내역에도 쌓이게 한다.
      setTimeout(() => setAcks((list) => list.filter((x) => x.id !== ack.id)), 10000);
    });

    es.onerror = () => {}; // 브라우저 EventSource 자동 재연결
    return () => es.close();
  }, [token]);

  if (notices.length === 0 && acks.length === 0) return null;

  return (
    <div className="notice-stack">
      {notices.map((n) => (
        <div key={n.id} className="notice-card">
          <div className="notice-title">{n.sender ? `${n.sender} · 알림` : '실시간 알림'}</div>
          <div className="notice-msg">{n.message}</div>
          {n.at ? <div className="notice-time">보낸시각 {fmtTime(n.at)}</div> : null}
          <div className="notice-actions">
            <button type="button" className="btn btn-primary btn-sm" onClick={() => confirm(n)}>수신확인</button>
          </div>
        </div>
      ))}
      {acks.map((a) => (
        <div key={a.id} className="notice-card notice-ack">
          <div className="notice-title">수신확인</div>
          <div className="notice-msg">{a.receiverName} 님이 확인했습니다.</div>
          <div className="notice-time">{fmtTime(a.at)}</div>
        </div>
      ))}
    </div>
  );
}
